// Portales que van a tener user Publisher enmascarado como Seeker
export const unifiedPanel = ['VAMX', 'DVPE'];
